var map = {
	"./ace_of_cups.png": 958,
	"./eight_of_cups.png": 959,
	"./five_of_cups.png": 960,
	"./four_of_cups.png": 961,
	"./king_of_cups.png": 962,
	"./knight_of_cups.png": 963,
	"./nine_of_cups.png": 964,
	"./page_of_cups.png": 965,
	"./queen_of_cups.png": 966,
	"./seven_of_cups.png": 967,
	"./six_of_cups.png": 968,
	"./ten_of_cups.png": 969,
	"./three_of_cups.png": 970,
	"./two_of_cups.png": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 957;